import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface NotificationIdsEntityParams {
  notification_ids: number[];
}
export class NotificationIdsEntity extends BaseEntityClass {
  notification_ids: number[];
  constructor(params: NotificationIdsEntityParams) {
    super();
    this.type = "notification_ids";
    this.entity_version = 2;
    this.notification_ids = params.notification_ids;
  }
}
